(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_brochure"] && !Shopify.designMode) return;
  try {
    'use strict';
  /* hovering or tabbing to a kind brings up its lead product's photograph, its caption and words under the frame, and
     its colour's glow; the photograph drifts a little with the mouse */
  const wrap = document.querySelector('.bro-wrap');
  if (wrap) {
    const $$ = s => [...wrap.querySelectorAll(s)];
    const GL = { feed: '--glow-feed', wear: '--glow-wear', play: '--glow-play', groom: '--glow-groom' };
    const set = i => {
      $$('.bro li').forEach(l => { l.classList.toggle('on', l.dataset.i === i); if (l.dataset.i === i) wrap.style.setProperty('--glow', `var(${GL[l.dataset.c]})`); });
      $$('.frame a, .bro-d').forEach(m => m.classList.toggle('on', m.dataset.i === i));
    };
    $$('.bro li').forEach(l => { l.addEventListener('mouseenter', () => set(l.dataset.i)); l.addEventListener('focusin', () => set(l.dataset.i)); });
    const fr = wrap.querySelector('.frame');
    if (fr && matchMedia('(pointer: fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      fr.addEventListener('mousemove', e => { const r = fr.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; fr.querySelectorAll('img').forEach(m => m.style.transform = `scale(1.06) translate(${-x * 14}px,${-y * 14}px)`); });
      fr.addEventListener('mouseleave', () => fr.querySelectorAll('img').forEach(m => m.style.transform = ''));
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_buy-box"] && !Shopify.designMode) return;
  try {
    'use strict';
  /* The product page: pick a size, choose how many, add to the basket. Stock and price come from the radio's data;
     what is already in the basket comes from Ounce.cart. Adding sends shopify:cart:lines-update from .pdp and asks for
     the basket drawer's section with it. Picking a size sends shopify:product:select. After an add the basket opens. On desktop every fold is open;
     on phones only the first. */
  const O = window.Ounce, pdp = document.querySelector('.pdp');
  if (matchMedia('(min-width: 801px)').matches) document.querySelectorAll('.fold').forEach(d => d.open = true);
  if (O && pdp) {
    const $ = s => pdp.querySelector(s), $$ = s => [...pdp.querySelectorAll(s)];
    const priceOut = $('[data-price]'), stockOut = $('[data-stock-msg]'), qtyOut = $('[data-qty]'), addBtn = $('[data-add]');
    let qty = 1;
    const chosen = () => $('input[name="variant"]:checked');
    const sync = () => {
      const v = chosen();
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = pdp.dataset.status === 'incoming' ? 'Arriving soon' : 'Sold out';
        stockOut.className = 'stock out'; stockOut.innerHTML = pdp.dataset.status === 'incoming' ? 'Not in the room yet.' : 'This one has all gone.'; return;
      }
      const stock = +v.dataset.stock, inBasket = O.cart.items.filter(i => String(i.variant_id) === v.value).reduce((n, i) => n + i.quantity, 0);
      priceOut.textContent = O.money(+v.dataset.price * qty) + (qty > 1 ? ` (${qty})` : '');
      qtyOut.textContent = qty; addBtn.textContent = 'Add to basket';
      if (inBasket >= stock) { addBtn.disabled = true; stockOut.className = 'stock out'; stockOut.textContent = `You have all ${stock} of them.`; }
      else { addBtn.disabled = false; stockOut.className = 'stock'; stockOut.textContent = stock <= 4 ? `${stock} left.` : `In the room, ready to go.`; }
    };
    document.addEventListener('ounce:cart', sync);
    // shopify:product:select when the buyer picks another option; the product comes from the page's view payload
    const json = s => { try { return JSON.parse(s || 'null'); } catch { return null; } };
    const viewed = json($('ounce-view-event')?.getAttribute('view-event-payload'))?.product;
    const names = json($('fieldset[data-names]')?.dataset.names) || [];
    const selected = r => {
      const SE = O.SE;
      if (!SE || !viewed) return;
      const selectedOptions = (json(r.dataset.options) || []).map((value, k) => ({ name: names[k] || '', value }));
      if (!selectedOptions.length) return;
      const d = SE.ProductSelectEvent.createPromise();
      pdp.dispatchEvent(new SE.ProductSelectEvent({ product: { id: viewed.id, title: viewed.title, handle: viewed.handle }, selectedOptions, promise: d.promise }));
      d.resolve({ variant: { id: r.value, title: r.dataset.title || '', availableForSale: !r.disabled, price: { amount: (+r.dataset.price / 100).toFixed(2), currencyCode: O.CURRENCY }, selectedOptions } });
    };
    $$('input[name="variant"]').forEach(r => r.addEventListener('change', () => { qty = 1; sync(); selected(r); }));
    $$('[data-q]').forEach(b => b.addEventListener('click', () => { const v = chosen(); if (!v) return; qty = Math.min(Math.max(1, qty + +b.dataset.q), +v.dataset.stock); sync(); }));
    addBtn.addEventListener('click', async () => {
      const v = chosen(); if (!v) return;
      addBtn.disabled = true;
      try {
        const c = await O.cartChange(pdp, 'add', 'product', [{ merchandiseId: v.value, quantity: qty }], async () => {
          const added = await O.api('cart/add.js', { items: [{ id: +v.value, quantity: qty }], sections: O.BAG, sections_url: location.pathname });
          O.drawBag(added.sections);
          return O.api('cart.js');
        });
        O.setCart(c);
        qty = 1; sync();
        O.bag.open(addBtn);   // show the basket after an add, so the next step is in front of them
        O.toast(`In the basket. <b>${c.item_count} ${c.item_count === 1 ? 'thing' : 'things'}</b>`);
      } catch (err) { sync(); O.toast(O.esc(err.message)); }
    });
    sync();
  }
  } catch(e) { console.error(e); }
})();

})();
